/* eslint-disable max-len */
import { Card, Collapse, Typography } from 'antd';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import annotationsImage from './images/annotations.jpg';
import bookDetailsImage from './images/bookDetails.jpg';
import filtersImage from './images/filters.jpg';
import logoutImage from './images/logout.jpg';
import odlImage from './images/odl.png';
import shareBookImage from './images/shareBook.jpg';
import styles from './styles.module.less';

const { Panel } = Collapse;

const Faq: FC = () => (
  <>
    <Helmet>
      <title>Frequently Asked Questions</title>
      <script src="https://player.vimeo.com/api/player.js" />
    </Helmet>
    <Card className={styles.wrapper}>
      <div className={styles.videoContainer}>
        <iframe
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen={true}
          className={styles.video}
          frameBorder="0"
          src="https://player.vimeo.com/video/663252352?h=0cf5d0d47e&badge=0&autopause=0&autoplay=1&player_id=0&app_id=58479"
          title="Okapi Digital Literacy Getting Started"
        />
      </div>
      <Typography.Title level={3}>About Okapi Digital Literacy &trade;</Typography.Title>
      <p>
        Okapi Digital Literacy &trade; is an ebook resource that enables teachers to view and share Okapi’s reading program with
        students. The resource contains Flying Start to Literacy &trade;, Despegando hacia la lectura &trade;, WorldWise:
        Content-based Learning &trade; and ExploraMundos &trade; : Student Books, Lesson Plans, Perspectives and Vocabulary
        Starters.
      </p>

      <img alt="Okapi Digital Literacy" className={styles.image} src={odlImage} />

      <Typography.Title level={3}>Digital Page Flip Ebooks</Typography.Title>
      <div>
        <p>
          Okapi Digital Literacy &trade; ebooks can be viewed on Windows PC, Mac, Chromebooks, iPad, iPhone, Android and other
          mobile devices. The resource has responsive design facilitating viewing on all platforms.
        </p>
        <p>
          Our digital page flip ebooks deliver a rich reading experience for teachers and students. Teachers can intuitively view
          the ebook in full screen mode with the page flipping effect.
        </p>
      </div>

      <Typography.Title level={3}>Frequently Asked Questions (FAQ)</Typography.Title>

      <Collapse bordered={false} className={styles.accordions}>
        <Panel key="1" header="How do I sign into Okapi Digital Literacy &trade; ?">
          <p>
            <strong>Schools</strong>
          </p>
          <p>
            Okapi staff will create a school account. The school IT administrator will be invited to setup their school account.
          </p>
          <p>
            <strong>Teachers</strong>
          </p>
          <p>The logged in school admin will add all teacher accounts. *See School/Teacher Registration Documents attached.</p>
        </Panel>

        <Panel key="2" header="How do I sign out of Okapi Digital Literacy &trade; ?">
          Click the drop down button beside your username located at the top-right of page when you wish to sign out.
          <img alt="Okapi Digital Literacy Logout" className={styles.image} src={logoutImage} />
        </Panel>

        <Panel key="3" header="How do I select the titles I wish to view?">
          Select filters on the left hand side menu here
          <img alt="Okapi Digital Literacy Filters" className={styles.image} src={filtersImage} />
        </Panel>

        <Panel key="4" header="How do I view the Digital Page Flip Ebook?">
          After selecting the titles with the correct filters click on the book title image. The ebook will open as a digital page
          flip ebook.
          <img alt="Okapi Digital Literacy Filters" className={styles.image} src={bookDetailsImage} />
        </Panel>

        <Panel key="5" header="How do I share ebooks with students?">
          On the ebook that you have open click “share link” on the top right hand menu. The link is now copied to your clipboard
          and can be pasted into email or your LMS to share with your student.
          <img alt="Okapi Digital Literacy Share book" className={styles.image} src={shareBookImage} />
        </Panel>

        <Panel key="6" header="How many links can I send students?">
          There are no limits to the number of links you can send students. Please note the links for books expire after 30 days.
        </Panel>

        <Panel key="7" header="How do I use ebook annotations?">
          To access annotations hover over the menu on the lower right hand side and click the icon for annotations (see image
          below)
          <img alt="Okapi Digital Literacy Annotations" className={styles.image} src={annotationsImage} />
        </Panel>
      </Collapse>
    </Card>
  </>
);

export default Faq;
